import { SVGProps, Ref, forwardRef } from 'react';

export const BellCrossedFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="m11.83 12.83 2.67 2.67 1-1L3.877 2.873l-.001.002L1.5.5l-1 1 2.67 2.67c-1.636 3.634-1.5 8.66-1.5 8.66h3.775c.26 1.47 1.008 2.668 2.556 2.668s2.297-1.199 2.557-2.668z"
                fill="currentColor"
            />
            <path d="M7.999.5c5.198 0 6.138 7.495 6.3 10.798L4.781 1.782A4.52 4.52 0 0 1 8 .5" fill="currentColor" />
        </g>
    </svg>
));
BellCrossedFilledSize16Glyph.displayName = 'BellCrossedFilledSize16Glyph';
